// extracted by mini-css-extract-plugin
export default {"item":"LangSwitcher_item__lTgkC"};